exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n  background-color: black;\n  font-size: 11px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/modules/general/alcance-titulos/alcance-titulos.component.scss
// module id = ../../../../../src/app/modules/general/alcance-titulos/alcance-titulos.component.scss
// module chunks = main